import React from 'react'
import { createProps } from './Constant'
import { IconProps } from './Type'

const IconRoundWarning: React.FC<IconProps> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...createProps({ ...props, settings: { noStroke: true } })}
  >
    <path d="M12 5.98993L19.53 18.9999H4.47L12 5.98993ZM2.74 17.9999C1.97 19.3299 2.93 20.9999 4.47 20.9999H19.53C21.07 20.9999 22.03 19.3299 21.26 17.9999L13.73 4.98993C12.96 3.65993 11.04 3.65993 10.27 4.98993L2.74 17.9999ZM11 10.9999V12.9999C11 13.5499 11.45 13.9999 12 13.9999C12.55 13.9999 13 13.5499 13 12.9999V10.9999C13 10.4499 12.55 9.99993 12 9.99993C11.45 9.99993 11 10.4499 11 10.9999ZM11 15.9999H13V17.9999H11V15.9999Z" />
  </svg>
)

export default IconRoundWarning
